/**
 * Stránka požadavků na digitalizaci.
 */

import PropTypes from 'prop-types';

import React from 'react';
import ReactDOM from 'react-dom';
import {indexById} from 'stores/app/utils';
import {connect} from 'react-redux';
import {ArrRequestDetail, Ribbon} from 'components/index';
import {FormInput, Icon, ListBox, RibbonGroup, SearchWithGoto, StoreHorizontalLoader} from 'components/shared';
import { FormattedMessage, injectIntl } from 'react-intl';
import { messageFor } from 'components/shared/lang/dynamicMessage';
import { arrPageMessages, requestStateMessages } from './messages';
import {Button} from '../../components/ui';
import {canSetFocus, focusWasSet, isFocusFor, setFocus} from 'actions/global/focus';
import * as arrRequestActions from 'actions/arr/arrRequestActions';
import {createDigitizationName} from 'components/arr/ArrUtils';
import ArrParentPage from './ArrParentPage';

import classNames from 'classnames';

import './ArrRequestPage.scss';
import {FOCUS_KEYS, urlFundRequests, getFundVersion} from '../../constants.tsx';
import { showConfirmDialog } from 'components/shared/dialog';

const AREA = "ARR_REQUEST";

class ArrRequestPage extends ArrParentPage {
    area = AREA;

    constructor(props) {
        super(props, 'arr-request-page');
    }

    static propTypes = {
        arrRegion: PropTypes.object.isRequired,
        focus: PropTypes.object.isRequired,
        userDetail: PropTypes.object.isRequired,
    };

    async componentDidMount() {
        super.componentDidMount()
        const {dispatch, match, history} = this.props;
        await this.resolveUrls();

        const fund = this.getActiveFund(this.props);
        const matchId = match.params.requestId;
        const urlRequestId = matchId ? parseInt(matchId) : null;
        if (fund) {
            dispatch(arrRequestActions.fetchListIfNeeded(fund.versionId));

            const requestDetail = fund.requestDetail;
            const requestId = requestDetail.id;
            if (urlRequestId == null && requestId != null) {
                history.replace(urlFundRequests(fund.id, getFundVersion(fund), requestId));
            } else if (urlRequestId !== requestId) {
                dispatch(arrRequestActions.selectDetail(fund.versionId, urlRequestId));
                history.replace(urlFundRequests(fund.id, getFundVersion(fund), urlRequestId));
            }
        }

        this.trySetFocus(this.props);
    }

    getPageUrl(fund) {
        return urlFundRequests(fund.id, getFundVersion(fund));
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        super.UNSAFE_componentWillReceiveProps(nextProps);

        const fund = this.getActiveFund(nextProps);
        if (fund) {
            this.props.dispatch(arrRequestActions.fetchListIfNeeded(fund.versionId));
        }

        this.trySetFocus(nextProps);
    }

    trySetFocus(props) {
        var {focus} = props;

        if (canSetFocus()) {
            if (isFocusFor(focus, FOCUS_KEYS.FUND_REQUEST, 1)) {
                this.refs.fundOutputList &&
                    this.setState({}, () => {
                        ReactDOM.findDOMNode(this.refs.fundOutputList).focus();
                    });
                focusWasSet();
            }
        }
    }

    handleShortcuts(action, e) {
        console.log('#handleShortcuts ArrRequestPage', '[' + action + ']', this);
        switch (action) {
            case 'newOutput':
                this.handleAddOutput();
                break;
            case 'area1':
                this.props.dispatch(setFocus(FOCUS_KEYS.FUND_REQUEST, 1));
                break;
            case 'area2':
                this.props.dispatch(setFocus(FOCUS_KEYS.FUND_REQUEST, 2));
                break;
            default:
                super.handleShortcuts(action);
        }
    }

    /**
     * Sestavení Ribbonu.
     * @return {Object} view
     */
    buildRibbon(readMode, closed) {
        const fund = this.getActiveFund(this.props);
        var itemActions = [];
        var altActions = [];
        if (fund) {
            const requestDetail = fund.requestDetail;
            const detailSelected = requestDetail.id !== null;
            const detailLoaded = requestDetail.fetched && !requestDetail.isFetching;

            if (!readMode && !closed) {
                if (detailSelected && !closed) {
                    itemActions.push(
                        <Button
                            key="send"
                            onClick={() => {
                                this.handleSend(requestDetail.id);
                            }}
                            disabled={!detailLoaded || requestDetail.data.state !== 'OPEN'}
                        >
                            <Icon glyph="fa-youtube-play" />
                            <div>
                                <span className="btnText">{<FormattedMessage {...arrPageMessages.ribbonActionArrFundRequestSend} />}</span>
                            </div>
                        </Button>,
                    );
                    itemActions.push(
                        <Button
                            key="delete"
                            onClick={() => {
                                this.handleDelete(requestDetail.id);
                            }}
                            disabled={!detailLoaded || requestDetail.data.state !== 'OPEN'}
                        >
                            <Icon glyph="fa-trash" />
                            <div>
                                <span className="btnText">{<FormattedMessage {...arrPageMessages.ribbonActionArrFundRequestDelete} />}</span>
                            </div>
                        </Button>,
                    );
                }
            }
        }

        var altSection;
        if (altActions.length > 0) {
            altSection = (
                <RibbonGroup key="alt" className="small">
                    {altActions}
                </RibbonGroup>
            );
        }

        var itemSection;
        if (itemActions.length > 0) {
            itemSection = (
                <RibbonGroup key="item" className="small">
                    {itemActions}
                </RibbonGroup>
            );
        }

        return <Ribbon arr subMenu fundId={fund ? fund.id : null} versionId={getFundVersion(fund)} altSection={altSection} itemSection={itemSection} />;
    }

    handleSelect = item => {
        const {dispatch, history} = this.props;
        const fund = this.getActiveFund(this.props);
        dispatch(arrRequestActions.selectDetail(fund.versionId, item.id));
        history.push(urlFundRequests(fund.id, getFundVersion(fund), item.id));
    };

    handleSend = id => {
        const fund = this.getActiveFund(this.props);
        this.props.dispatch(arrRequestActions.sendRequest(fund.versionId, id));
    };

    handleDelete = async (id) => {
        const {dispatch} = this.props;
        const fund = this.getActiveFund(this.props);
        const response = await dispatch(showConfirmDialog(this.props.intl.formatMessage(arrPageMessages.ribbonActionArrFundRequestDeleteConfirm)))
        if (response) {
            this.props.dispatch(arrRequestActions.deleteRequest(fund.versionId, id));
        }
    };

    renderListItem = props => {
        const {item} = props;
        const {userDetail} = this.props;

        var cls = {};

        return (
            <div className={classNames(cls)}>
                <div className="name">{createDigitizationName(item, userDetail)}</div>
                <div className="state">
                    {<FormattedMessage {...arrPageMessages.requestTitleState} />}: {this.props.intl.formatMessage(messageFor(requestStateMessages, item.state, arrPageMessages.requestTitleStateOPEN))}
                </div>
            </div>
        );
    };

    handleFilterType = e => {
        const fund = this.getActiveFund(this.props);
        const {
            requestList: {filter},
        } = fund;

        const val = e.target.value;
        const newFilter = {
            ...filter,
            type: val,
        };

        this.props.dispatch(arrRequestActions.filterList(fund.versionId, newFilter));
    };

    handleFilterText = filterText => {
        const fund = this.getActiveFund(this.props);
        const {
            requestList: {filter},
        } = fund;

        const newFilter = {
            ...filter,
            description: filterText,
        };

        this.props.dispatch(arrRequestActions.filterList(fund.versionId, newFilter));
    };

    handleFilterTextClear = () => {
        this.handleFilterText(null);
    };

    renderLeftPanel(readMode, closed) {
        const fund = this.getActiveFund(this.props);
        const {requestList, requestDetail} = fund;

        let activeIndex = null;
        if (requestDetail.id !== null) {
            activeIndex = indexById(requestList.rows, requestDetail.id);
        }

        return (
            <div className="fund-request-list-container">
                <div className="filter">
                    <FormInput
                        type="select"
                        className="type"
                        onChange={this.handleFilterType}
                        value={requestList.filter.type}
                    >
                        <option value={''}>{this.props.intl.formatMessage(arrPageMessages.globalAll)}</option>
                        <option value="DIGITIZATION" key="DIGITIZATION">
                            {this.props.intl.formatMessage(arrPageMessages.requestTitleTypeDIGITIZATION)}
                        </option>
                        <option value="DESTRUCTION" key="DESTRUCTION">
                            {this.props.intl.formatMessage(arrPageMessages.requestTitleTypeDaoDESTRUCTION)}
                        </option>
                        <option value="TRANSFER" key="TRANSFER">
                            {this.props.intl.formatMessage(arrPageMessages.requestTitleTypeDaoTRANSFER)}
                        </option>
                        {/* Požadavky typu DAO_LINK se ve filtru zatím nenabízejí. */}
                    </FormInput>
                    <SearchWithGoto
                        onFulltextSearch={this.handleFilterText}
                        onClear={this.handleFilterTextClear}
                        placeholder={this.props.intl.formatMessage(arrPageMessages.searchInputSearch)}
                        filterText={requestList.filter.description}
                        showFilterResult={true}
                        type="INFO"
                        itemsCount={requestList.filteredRows ? requestList.filteredRows.length : 0}
                        allItemsCount={requestList.count}
                    />
                </div>
                <StoreHorizontalLoader store={requestList} />
                {requestList.fetched && (
                    <ListBox
                        className="fund-request-listbox"
                        ref="fundDigitizationRequestList"
                        items={requestList.rows}
                        activeIndex={activeIndex}
                        renderItemContent={this.renderListItem}
                        onFocus={this.handleSelect}
                        onSelect={this.handleSelect}
                    />
                )}
            </div>
        );
    }

    renderCenterPanel(readMode, closed) {
        const fund = this.getActiveFund(this.props);
        const {requestDetail} = fund;

        return <ArrRequestDetail versionId={fund.versionId} fund={fund} requestDetail={requestDetail} />;
    }

    hasPageShowRights(userDetail, activeFund) {
        return userDetail.hasRdPage(activeFund ? activeFund.id : null);
    }
}

function mapStateToProps(state) {
    const {arrRegion, refTables, focus, userDetail} = state;
    return {
        arrRegion,
        focus,
        userDetail,
        rulDataTypes: refTables.rulDataTypes,
        descItemTypes: refTables.descItemTypes,
        ruleSet: refTables.ruleSet,
        templates: refTables.templates,
        outputTypes: refTables.outputTypes.items,
    };
}

export default connect(mapStateToProps)(injectIntl(ArrRequestPage));
